import { selectProduct } from "@/store/slices/product";
import React from "react";
import { useSelector } from "react-redux";
import styles from "./discount.module.scss";

const ProductDetailsDiscount = () => {
  const productState = useSelector(selectProduct);

  if (!productState.data || !productState.selectedPrice?.discount?.name) {
    return <></>;
  }
  return (
    <div className={styles.text_dis}>
      <p>
        <span>{productState.selectedPrice?.discount?.name}</span>
      </p>
    </div>
  );
};

export default ProductDetailsDiscount;
